import {useState, useEffect, useRef} from 'react'

const originalTitle = document.title
const url =
  process.env.NODE_ENV === 'production' ? globalThis.__env.REACT_APP_REDIRECT_URI : process.env.REACT_APP_REDIRECT_URI

function revertOriginalTitle() {
  document.title = originalTitle
}

function revertOriginalFavIcon() {
  const favicon = document.getElementById('favicon')
  favicon.href = `${url}/deloitte-logo.ico`
}

function useTabHighlightNotification() {
  const [message, setMessage] = useState(null)
  const notificationIntervalId = useRef(null)

  function setTabNotification() {
    setMessage(' ' + originalTitle)
    faviconUpdate()
  }

  function clearTabNotification() {
    revertOriginalTitle()
    setMessage(null)
  }

  const faviconUpdate = async () => {
    const favicon = document.getElementById('favicon')
    if (favicon.href.includes('exclamation-mark.ico')) {
      favicon.href = `${url}/deloitte-logo.ico`
    } else {
      favicon.href = `${url}/exclamation-mark.ico`
    }
    notificationIntervalId.current = setTimeout(function () {
      faviconUpdate()
    }, 500)
  }

  function stopNotifying() {
    clearInterval(notificationIntervalId.current)
    revertOriginalFavIcon()
    notificationIntervalId.current = null
  }

  useEffect(() => {
    if (notificationIntervalId.current && !message) stopNotifying()
  }, [message])

  useEffect(() => {
    return () => {
      if (document.title !== originalTitle) revertOriginalTitle()
      revertOriginalFavIcon()
      if (notificationIntervalId.current) clearTimeout(notificationIntervalId.current)
    }
  }, [])

  return [setTabNotification, clearTabNotification]
}

export default useTabHighlightNotification
